<style scoped lang="sass">
#pool-details
  padding: var(--base-padding)
  .owner
    .owner-name
      display:          flex
      align-items:      center
      .avatar
        margin-right: 0.5rem
  .description
    margin-bottom: 1rem
</style>
<template>
  <div id="pool-details">
    <div class="owner">
      <strong>Owner</strong>
      <div class="owner-name">
        <img :src="pool.owner.avatar_url" class="avatar">
        <span>{{pool.owner.private_name}}</span>
      </div>
    </div>
    <br />
    <div class="description" v-if="pool.description">
      {{pool.description}}
    </div>
    <div class="scoring">
      <strong>Making your picks</strong>
      <br />
      {{pool.pool_style.description}}
      <br />
      Number of picks: {{pool.pool_style_config.value}}
      <br />
      <br />
      <strong>How scoring works</strong>
      <br />
      {{pool.scoring_method.description}}
      <br />
      <div v-for="cutoffRange in cutoffRanges">
        <span v-if="cutoffRange.start === cutoffRange.end">
          {{cutoffRange.start}}{{indicator(cutoffRange.start)}}
        </span>
        <span v-else>
          {{cutoffRange.start}}{{indicator(cutoffRange.start)}} to
          {{cutoffRange.end}}{{indicator(cutoffRange.end)}}
        </span>
        place worth {{pluralize('point', cutoffRange.value, true)}}
      </div>
      <div>
        All other players who make the cut or get MDF worth {{pluralize('point', pool.scoring_method_config.cutoffHash.default, true)}}
      </div>
      <br />
      <div v-for="option in pool.scoring_method_config.options">
        <div v-if="option.name === 'Low round'">
          {{pluralize('point', option.value, true)}} for each pick shooting the low round per day
        </div>
        <div v-if="option.name === 'All picks make cut'">
          {{pluralize('point', option.value, true)}} if all picks make the cut and finish or get MDF
        </div>
      </div>
      <br />
      Ties are broken by best to worst finishing players
    </div>
  </div>
</template>
<script>
import indicator from 'ordinal/indicator';
import pluralize from 'pluralize';

export default {
  name: 'PoolDetails',
  props: {
    pool: Object
  },
  computed: {
    cutoffRanges() {
      const cutoffs = this.pool.scoring_method_config.cutoffHash.cutoffs || [];
      return cutoffs.map(({cutoff}, index) => {
        return {
          start: cutoffs[index - 1] ? parseInt(cutoffs[index - 1].cutoff) + 1 : 1,
          end:   parseInt(cutoffs[index].cutoff),
          value: cutoffs[index].value
        };
      });
    }
  },
  methods: {
    indicator(num) {
      return indicator(num);
    },
    pluralize
  }
};
</script>
